export type TRegionCoverageMap = {
  region: string;
  [index: string]: string | null;
};

export const ANTI_THEFT_DEVICE_STATES = ['IL'];
export const AUTOMATIC_EMERGENCY_BRAKING_STATES = ['SC'];
export const BUSINESS_USE_STATES = ['SC'];
export const DEFENSIVE_DRIVER_STATES = ['SC'];
export const MATURE_DRIVER_STATES_CONFIG = [
  {
    region: 'IL',
    age: 55,
  },
  {
    region: 'OH',
    age: 60,
  },
  {
    region: 'TN',
    age: 55,
  },
];

const IN_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'IN',
  '25000/50000': '50000/50000',
  '50000/50000': '25000/50000',
};

const MO_UMBI_UIMBI_COVERAGE_MAP: TRegionCoverageMap = {
  region: 'MO',
  '25000/50000': 'null',
  null: '25000/50000',
};

export const REGION_COVERAGE_RULES = {
  UMBI_MATCHES_UIMBI: ['IL', 'MO'],
  UMBI_UIMBI_COVERAGE_MAP: [
    IN_UMBI_UIMBI_COVERAGE_MAP,
    MO_UMBI_UIMBI_COVERAGE_MAP,
  ],
  UMPD_REQUIRES_UMBI: ['IN', 'OH', 'TN'],
  SKIP_UIMBI_SIDE_EFFECT: ['OH'],
  VUMPD_REQUIRES_NO_COMP_COLL: ['OH', 'IL'],
};

export const REGION_QUOTE_SUMMARY_RULES = {
  SHOW_CARBON_OFFSET_COVERAGE: ['AZ', 'IL', 'IN', 'MO', 'OH', 'TN'],
};

export default {
  ANTI_THEFT_DEVICE_STATES,
  AUTOMATIC_EMERGENCY_BRAKING_STATES,
  BUSINESS_USE_STATES,
  DEFENSIVE_DRIVER_STATES,
  MATURE_DRIVER_STATES_CONFIG,
  REGION_COVERAGE_RULES,
  REGION_QUOTE_SUMMARY_RULES,
} as const;
